export const palette = ['#2463eb', '#40b870', '#dc2625', '#8825eb', '#F5D90A', '#b3d4ff', '#9aa5b5', '#a4dc6c', '#C11574'];

export const dashboardPalette = ['#3B83F6', '#06B6D5', '#A856F7', '#EC4899', '#12B981', '#84CC15', '#F59E0C', '#FA7315', '#F43F5F'];

export const sentimentPalette = ['#D1FAE5', '#FFFBD1', '#FEE2E2'];

export const sentimentPaletteMap = {
  'NEGATIVE': '#FEE2E2',
  'NEUTRAL': '#FFFBD1',
  'POSITIVE': '#D1FAE5'
}

export const dashboardSentimentPaletteMap = {
  'POSITIVE': '#22C55F',
  'NEUTRAL': '#FFCC33',
  'NEGATIVE': '#EF4444',
};

export const otherCategoryColor = '#64758B';

export const colorIndexes = Array.from({ length: 8 }, (value, index) => index);
export const colorClasses = colorIndexes.map((value) => `color${value}`);
